<template>
	<v-dialog
		v-model="visible"
		max-width="600"
		persistent
	>
		<v-alert
			border="top"
			colored-border
			:color="color"
			class="mb-0 px-8 py-6"
		>
			<div class="context">
				<v-icon class="mr-2" v-if="isWarning" :color="color">mdi-alert-outline</v-icon>
				<div class="title-text" v-for="(t, index) in text" :key="`t_${index}`">{{ t }}</div>
			</div>
		</v-alert>
	</v-dialog>
</template>
<script>
export default {
	name: 'DialogNotice',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		text: {
			type: Array,
			default: () => []
		},
		color: {
			type: String,
			default: '#00AAFD'
		},
		isWarning: {
			type: Boolean,
			default: false
		}
	}
}
</script>
<style lang="scss" scoped>
.context {
	display: flex;
	flex-flow: column nowrap;
}
</style>